module.exports = __webpack_public_path__ + "assets/img_seamless.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_seamless.jpg
 ** module id = 131
 ** module chunks = 1
 **/